// Toast.jsx
import React from "react";
import "./Toast.css";

export default function Toast({ show, type, message }) {
  if (!show) return null;
  return <div className={`toast toast-${type}`}>{message}</div>;
}
